import React, {Fragment} from "react"

// Material-UI Core
import {makeStyles, withStyles} from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import LinearProgress from '@material-ui/core/LinearProgress'

// Material-UI Icon

// Custom Style
import attachmentChipStyle from "../../styles/jss/components/chip/attachmentChipStyle"
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Typography from "@material-ui/core/Typography";


// Customer List
const AttachmentListItem = withStyles(theme => ({
	root: {
		height: theme.spacing(4),
		paddingTop: theme.spacing(0),
		paddingBottom: theme.spacing(0),
		textDecoration:"line-through"
	},

	secondaryAction: {
		paddingRight: 150
	},
})) (ListItem)


const useStyles = makeStyles(theme => attachmentChipStyle(theme))

const AttachmentDeletedChip = props => {
	const classes = useStyles()
	const {id, filename, fileSize, fileExtension, uploading} = props

	return (
		<Fragment>
			<Box key={id} className={classes.attachmentLabel}>
				<List>
					<AttachmentListItem>
						<ListItemAvatar>
							<img src={require('../../img/file/' + fileExtension.toLowerCase() + '.png')} className={classes.fileTypeImage} />
						</ListItemAvatar>

						<ListItemText
							classes={{primary: classes.attachmentNameText, secondary: classes.attachmentSizeText}}
							primary={filename}
							secondary={uploading ? <LinearProgress /> : fileSize ?  fileSize / 1024 > 1024 ? (fileSize / 1024 / 1024).toFixed(2) + " MB" : (fileSize / 1024).toFixed(2) + " KB" : ""}
						/>
						<ListItemSecondaryAction >
							<Typography variant="overline" display="block" gutterBottom>
								DELETED
							</Typography>
						</ListItemSecondaryAction>

					</AttachmentListItem>
				</List>
			</Box>
		</Fragment>
	)
}


export default AttachmentDeletedChip
